import React, { FC } from 'react';
import { useLocation } from 'react-router';

import { Toc, TocItem } from '@gravity-ui/uikit';
import { Link } from 'client/blocks-redesign/Link/Link';

export const SideMenu: FC<{ menuItems: TocItem[] }> = ({ menuItems }) => {
    const { pathname, hash } = useLocation();
    const currentPath = `${pathname}${hash || '#'}`;
    return (
        <Toc
            value={currentPath}
            items={menuItems.map((item) => ({
                value: item.value,
                content: (
                    <Link to={item.value} isCurrentPath={currentPath === `${item.value}#`}>
                        {item.content}
                    </Link>
                ),
                items: item?.items
                    ? item.items.map((item) => ({
                          value: item.value,
                          content: (
                              <Link to={item.value} isCurrentPath={currentPath === item.value}>
                                  {item.content}
                              </Link>
                          ),
                      }))
                    : undefined,
            }))}
        />
    );
};
